var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInputContainer',{staticClass:"FormInput",attrs:{"inputId":`I${_vm._uid}`,"label":_vm.label,"errors":_vm.errors,"required":_vm.required}},[_c('input',_vm._g(_vm._b({attrs:{"id":`I${_vm._uid}`,"type":_vm.type},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),{ [_vm.lazy ? 'change' : 'input']: _vm.handleInput }))])
}
var staticRenderFns = []

export { render, staticRenderFns }